import { RgTraverse as c, RgChildren as g, RG_TYPE as p } from "@project-rouge/rg-core";
import { Euler as m, Quaternion as f, MathUtils as s } from "three";
import { DegToRadV3 as a } from "../../geometry-utils/three/index5.js";
import { EulerToSignedAngle as d } from "../../utils/index9.js";
const r = new m(), t = new f(), u = new f(), w = (o) => {
  let n = [0, 0, 0];
  c(o, (l) => {
    if (!!g[p.Building].includes(l.type))
      return n = structuredClone(l.rot), !1;
  }), r.fromArray(a(n));
  const e = d(r) * s.RAD2DEG % 90;
  let i = e;
  Math.abs(e) > 45 && (i -= 90 * Math.sign(e)), t.setFromEuler(r), u.setFromEuler(
    new m(0, i * s.DEG2RAD, 0)
  ), t.premultiply(u), o.rot = a(
    r.setFromQuaternion(t).toArray().slice(0, 3)
  );
};
export {
  w as snapRotation
};
//# sourceMappingURL=index3.js.map
